import { HttpRequest, IHttpClient } from "@features/shared/request/model";
import { IStreakPeriod, IStreakStats } from "../entities/streak";

const SERVER_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

export class TStreakApi {
    constructor(private httpClient: IHttpClient) {}

    async getStreakStats() {
        return await this.httpClient.do<IStreakStats>(`${SERVER_URL}/streak/stats`);
    }

    async getStreakList() {
        return await this.httpClient.do<IStreakPeriod[] | null>(`${SERVER_URL}/streak/list`);
    }
}

export const StreakApi = new TStreakApi(HttpRequest);
